// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlanearVisita_overlay__Gya3S {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #1e1e1ed7;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    padding: 20px;
    box-sizing: border-box;
}

.PlanearVisita_popup__tvBBR {
    background-color: #1e1e1e;
    width: 90%;
    max-width: 500px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    overflow: auto;
    position: relative;
    max-height: 90vh;
}

.PlanearVisita_closeButton__ZLcZY {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #ffffff;
    z-index: 2;
    padding: 8px;
    line-height: 1;
}

.PlanearVisita_imageSection__-yaM4 img {
    width: 100%;
    height: auto;
    display: block;
}

.PlanearVisita_content__0dc0U {
    padding: 20px;
    text-align: center;
}

.PlanearVisita_subtitle__2C6G2 {
    font-family: "Space Grotesk", sans-serif;
    font-weight: 700;
    font-size: 1.5rem;
    color: #ffffff;
    margin-bottom: 15px;
}

.PlanearVisita_description__mv9Dw {
    font-size: 1rem;
    color: #ffffff;
    margin-bottom: 15px;
    line-height: 1.5;
    text-align: left;
}

.PlanearVisita_horario__-Qd0K {
    font-size: 1rem;
    color: #ffffff;
    margin-bottom: 15px;
    line-height: 1.5;
    text-align: left;
}

.PlanearVisita_navigationButtons__4idOh {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.PlanearVisita_navigationButton__XNbJH {
    background-color: #007bff;
    color: #ffffff;
    padding: 12px 24px;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 140px;
}

.PlanearVisita_navigationButton__XNbJH:hover {
    background-color: #0056b3;
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* Media Queries para responsividade */
@media screen and (max-width: 480px) {
    .PlanearVisita_popup__tvBBR {
        width: 100%;
        max-height: 95vh;
    }

    .PlanearVisita_content__0dc0U {
        padding: 15px;
    }

    .PlanearVisita_subtitle__2C6G2 {
        font-size: 1.25rem;
    }

    .PlanearVisita_description__mv9Dw {
        font-size: 0.9rem;
    }

    .PlanearVisita_navigationButtons__4idOh {
        flex-direction: column;
        gap: 10px;
    }

    .PlanearVisita_navigationButton__XNbJH {
        width: 100%;
        padding: 10px 20px;
    }
}

/* Para telas muito pequenas */
@media screen and (max-height: 600px) {
    .PlanearVisita_popup__tvBBR {
        max-height: 98vh;
    }

    .PlanearVisita_description__mv9Dw {
        margin-bottom: 10px;
    }

    .PlanearVisita_navigationButtons__4idOh {
        margin-top: 10px;
        margin-bottom: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Site/PlanearVisita/PlanearVisita.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA,sCAAsC;AACtC;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA,8BAA8B;AAC9B;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ","sourcesContent":[".overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: #1e1e1ed7;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.popup {\r\n    background-color: #1e1e1e;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\r\n    overflow: auto;\r\n    position: relative;\r\n    max-height: 90vh;\r\n}\r\n\r\n.closeButton {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 16px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.5rem;\r\n    cursor: pointer;\r\n    color: #ffffff;\r\n    z-index: 2;\r\n    padding: 8px;\r\n    line-height: 1;\r\n}\r\n\r\n.imageSection img {\r\n    width: 100%;\r\n    height: auto;\r\n    display: block;\r\n}\r\n\r\n.content {\r\n    padding: 20px;\r\n    text-align: center;\r\n}\r\n\r\n.subtitle {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-weight: 700;\r\n    font-size: 1.5rem;\r\n    color: #ffffff;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.description {\r\n    font-size: 1rem;\r\n    color: #ffffff;\r\n    margin-bottom: 15px;\r\n    line-height: 1.5;\r\n    text-align: left;\r\n}\r\n\r\n.horario {\r\n    font-size: 1rem;\r\n    color: #ffffff;\r\n    margin-bottom: 15px;\r\n    line-height: 1.5;\r\n    text-align: left;\r\n}\r\n\r\n.navigationButtons {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.navigationButton {\r\n    background-color: #007bff;\r\n    color: #ffffff;\r\n    padding: 12px 24px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    min-width: 140px;\r\n}\r\n\r\n.navigationButton:hover {\r\n    background-color: #0056b3;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Media Queries para responsividade */\r\n@media screen and (max-width: 480px) {\r\n    .popup {\r\n        width: 100%;\r\n        max-height: 95vh;\r\n    }\r\n\r\n    .content {\r\n        padding: 15px;\r\n    }\r\n\r\n    .subtitle {\r\n        font-size: 1.25rem;\r\n    }\r\n\r\n    .description {\r\n        font-size: 0.9rem;\r\n    }\r\n\r\n    .navigationButtons {\r\n        flex-direction: column;\r\n        gap: 10px;\r\n    }\r\n\r\n    .navigationButton {\r\n        width: 100%;\r\n        padding: 10px 20px;\r\n    }\r\n}\r\n\r\n/* Para telas muito pequenas */\r\n@media screen and (max-height: 600px) {\r\n    .popup {\r\n        max-height: 98vh;\r\n    }\r\n\r\n    .description {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .navigationButtons {\r\n        margin-top: 10px;\r\n        margin-bottom: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `PlanearVisita_overlay__Gya3S`,
	"popup": `PlanearVisita_popup__tvBBR`,
	"closeButton": `PlanearVisita_closeButton__ZLcZY`,
	"imageSection": `PlanearVisita_imageSection__-yaM4`,
	"content": `PlanearVisita_content__0dc0U`,
	"subtitle": `PlanearVisita_subtitle__2C6G2`,
	"description": `PlanearVisita_description__mv9Dw`,
	"horario": `PlanearVisita_horario__-Qd0K`,
	"navigationButtons": `PlanearVisita_navigationButtons__4idOh`,
	"navigationButton": `PlanearVisita_navigationButton__XNbJH`
};
export default ___CSS_LOADER_EXPORT___;
